import React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconClose = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconClose.dimensions.width} ${IconClose.dimensions.height}`}
      {...otherProps}
    >
      <Path
        d="M17.23 2 9.5 9.727 1.773 2 1 2.773 8.727 10.5 1 18.23l.773.77L9.5 11.273 17.23 19l.77-.77-7.727-7.73L18 2.773 17.23 2Z"
        fill={color || Color.premiumBlack}
      />
    </Svg>
  )
}

IconClose.dimensions = {
  width: 20,
  height: 20,
}

export default IconClose
